/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
// TODO: Handle possibility of user getting negative savings
// this happens when our interest rate is higher than their
// current interest rate.
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Accordion } from 'react-accessible-accordion';
import ResultSubsection from '../shared/ResultSubsection';
import 'react-accessible-accordion/dist/minimal-example.css';

import CTA from '../shared/CTA';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { mp } from '../../constants/utils';
import { FAKE_RESPONSE_DEBT } from '../../constants/questionnaires';
import { FlowHeader } from '../GoalsFlow/styles';
import Title from '../shared/Title';
import Text from '../shared/Text';
import {
  StyledResultTable,
  StyledCustomDivision,
  StyledBold,
  WhiteLogo,
  StyledResults,
  FirstSection,
} from '../shared/resultsStyles';
import CurrentSituation from '../shared/CurrentSituation';
import Oops from '../shared/Oops';
import Loading from '../shared/Loading';
import QuestionSection from '../shared/QuestionSection';
import { palette } from '../../constants/styles';
import Icon from '../shared/Icon';
import NumberTip from '../shared/NumberTip';
import StartPlanResultCTA from '../shared/StartPlanResultCTA';

const FinalPunchStatementContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const FinalPunchStatement = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  width: 100%;
`;

// Virtual Division

const StyledPickMonths = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

const StyledPreResult = css`
  margin: 0px;
  line-height: 1.2;
`;

const generateCustomMessage = (data) => {
  let debtText = '';
  if (data.add_card_1) {
    debtText = `Debo $${data.debt_1
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} a mi tarjeta ${data.type_of_card_1.replace(
      /_/g,
      ' ',
    )} de ${data.bank_1}\nDebo $${data.debt_2
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} a mi tarjeta ${data.type_of_card_2.replace(
      /_/g,
      ' ',
    )} de ${data.bank_2}\n`;
  } else {
    debtText = `Debo $${data.debt_1
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} a mi tarjeta ${data.type_of_card_1.replace(
      /_/g,
      ' ',
    )} de ${data.bank_1}`;
  }
  return `Hola 👋 me gustaría platicar con un experto para cambiar mi deuda.\n\n${debtText}`;
};

class Results extends Component {
  state = {
    paymentPeriods: [],
    optionsSelector: [],
    paymentPeriodsIndex: 0,
    failed: false,
    openConvertingModal: false,
  };

  componentWillMount() {
    if (process.env.REACT_APP_NODE_ENV === 'development') {
      this.setState({ paymentPeriods: [6, 12, 18], paymentPeriodsIndex: 0 });
    }

    setTimeout(() => {
      const { result } = this.props;
      if (!result.data && process.env.NODE_ENV !== 'development') {
        this.setState({ failed: true });
      }
    }, 10000);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.result.data) {
      mp('Deuda | Resultados | Error');
    } else {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ customMessage: generateCustomMessage(nextProps.result.data) });
      mp('Deuda | Resultados | Entra');
      this.updatePaymentPeriods(
        nextProps.result.data.payment_periods_options,
        nextProps.result.data.payment_periods_index,
      );
      const options = [];
      for (let i = 0; i < nextProps.result.data.payment_periods_options.length; i += 1) {
        options.push({
          value: nextProps.result.data.payment_periods_options[i],
          label: `${nextProps.result.data.payment_periods_options[i]} meses`,
        });
      }
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ optionsSelector: options });
    }
  }

  componentDidUpdate = () => {
    window.onbeforeunload = () => {
      mp('Deuda | Resultados | Se va');
    };
  };

  handleChange = (value) => {
    const { paymentPeriods, paymentPeriodsIndex } = this.state;
    if (paymentPeriodsIndex + value < paymentPeriods.length && paymentPeriodsIndex + value >= 0) {
      this.setState({ paymentPeriodsIndex: paymentPeriodsIndex + value });
    }
  };

  updatePaymentPeriods = (periods, index) => {
    this.setState({ paymentPeriods: periods, paymentPeriodsIndex: index });
  };

  render() {
    const { failed, paymentPeriodsIndex, customMessage, paymentPeriods } = this.state;

    let result = {};
    if (process.env.REACT_APP_NODE_ENV === 'development') {
      result.data = FAKE_RESPONSE_DEBT;
      // const plan = { data: null };
    } else {
      // eslint-disable-next-line react/destructuring-assignment, prefer-destructuring
      result = this.props.result;
    }

    // eslint-disable-next-line no-nested-ternary
    return result.data && !failed ? (
      <Fragment>
        <StyledResults>
          <FlowHeader>
            <Link to="/" onClick={this.forceUpdate}>
              <WhiteLogo src={FinautaWhiteLogo} id="logo" />
            </Link>
          </FlowHeader>
          <Fragment>
            <FirstSection>
              <CurrentSituation
                title="Tu situación actual"
                content={
                  result.data.add_card_1 ? (
                    <Fragment>
                      <Text type="body1">Cuentas con dos deudas:</Text>
                      <ul style={{ listStyle: 'none', padding: '0px', margin: '0px' }}>
                        <li>
                          <Text type="body1">
                            <StyledBold>
                              <NumberFormat
                                value={result.data.debt_1}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                                decimalScale={0}
                              />
                            </StyledBold>{' '}
                            en tu tarjeta{' '}
                            <StyledBold>
                              <span style={{ textTransform: 'capitalize' }}>
                                {result.data.type_of_card_1.replace(/_/g, ' ')}
                              </span>
                            </StyledBold>{' '}
                            de{' '}
                            <StyledBold>
                              <span style={{ textTransform: 'capitalize' }}>
                                {result.data.bank_1}
                              </span>
                            </StyledBold>
                          </Text>
                        </li>
                        <li>
                          <Text type="body1">
                            <StyledBold>
                              <NumberFormat
                                value={result.data.debt_2}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                                decimalScale={0}
                              />
                            </StyledBold>{' '}
                            en tu tarjeta{' '}
                            <StyledBold>
                              <span style={{ textTransform: 'capitalize' }}>
                                {result.data.type_of_card_2.replace(/_/g, ' ')}
                              </span>
                            </StyledBold>{' '}
                            de{' '}
                            <StyledBold>
                              <span style={{ textTransform: 'capitalize' }}>
                                {result.data.bank_2}
                              </span>
                            </StyledBold>
                          </Text>
                        </li>
                      </ul>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Text type="body1">Cuentas con una deudas:</Text>
                      <ul style={{ listStyle: 'none', padding: '0px', margin: '0px' }}>
                        <li>
                          <Text type="body1">
                            <StyledBold>
                              <NumberFormat
                                value={result.data.debt_1}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                                decimalScale={0}
                              />
                            </StyledBold>{' '}
                            en tu tarjeta{' '}
                            <StyledBold>
                              <span style={{ textTransform: 'capitalize' }}>
                                {result.data.type_of_card_1.replace(/_/g, ' ')}
                              </span>
                            </StyledBold>{' '}
                            de{' '}
                            <StyledBold>
                              <span style={{ textTransform: 'capitalize' }}>
                                {result.data.bank_1}
                              </span>
                            </StyledBold>
                          </Text>
                        </li>
                      </ul>
                    </Fragment>
                  )
                }
              />
              <FinalPunchStatementContainer>
                <FinalPunchStatement>
                  <Title level={2} styles={StyledPreResult} align="center" breakable medium>
                    Ahorra{' '}
                    <span style={{ fontSize: '1.2em' }}>
                      <StyledBold>
                        <NumberFormat
                          value={result.data.total_savings[paymentPeriodsIndex]}
                          displayType="text"
                          thousandSeparator
                          prefix="$"
                          decimalScale={0}
                        />
                      </StyledBold>
                    </span>{' '}
                    en intereses cambiando tu deuda
                  </Title>
                  {/* <Title level={2} styles={StyledPreResult} align="center" breakable medium>Ahorra</Title>
                  <Title level={1} styles={StyledPreResult} align="center" breakable medium><StyledBold><NumberFormat value={result.data.total_savings[paymentPeriodsIndex]} displayType="text" thousandSeparator prefix="$" decimalScale={0} /></StyledBold></Title>
                  <Title level={2} styles={StyledPreResult} align="center" breakable medium>en intereses cambiando tu deuda</Title> */}
                </FinalPunchStatement>
              </FinalPunchStatementContainer>

              <StyledPickMonths>
                <Text type="body2" breakable>
                  Liquidando en
                </Text>
                <Icon
                  icon="minusIcon"
                  color={
                    paymentPeriods[paymentPeriodsIndex - 1]
                      ? palette.finautaOrange
                      : palette.basicGray
                  }
                  size={25}
                  style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer' }}
                  onClick={() => {
                    this.handleChange(-1);
                  }}
                />
                <Title
                  level={2}
                  styles={StyledPreResult}
                  breakable
                  medium
                >{`${paymentPeriods[paymentPeriodsIndex]}`}</Title>
                <Icon
                  icon="plusIcon"
                  color={
                    paymentPeriods[paymentPeriodsIndex + 1]
                      ? palette.secondaryColor
                      : palette.basicGray
                  }
                  size={25}
                  style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer' }}
                  onClick={() => {
                    this.handleChange(1);
                  }}
                />
                <Text type="body2" breakable>
                  meses
                </Text>
              </StyledPickMonths>

              <table cellPadding={0} cellSpacing={0} style={{ width: '100%', margin: '15px 0px' }}>
                <StyledResultTable>
                  <tr>
                    <th />
                    {result.data.add_card_1 ? (
                      <th>
                        <Text type="body2" medium>
                          Tus bancos
                        </Text>
                      </th>
                    ) : (
                      <th>
                        <Text type="body2" medium>
                          Tu banco
                        </Text>
                      </th>
                    )}
                    <th>
                      <Text type="body2" medium>
                        Tu mejor opción
                      </Text>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <Text type="body2">Pago mensual</Text>
                    </td>
                    <td>
                      <Text type="body2">
                        <StyledBold>
                          <NumberFormat
                            value={result.data.original_monthly_payment[paymentPeriodsIndex]}
                            displayType="text"
                            thousandSeparator
                            prefix="$"
                            decimalScale={0}
                          />
                        </StyledBold>
                      </Text>
                    </td>
                    <td>
                      <Text type="body2">
                        <StyledBold>
                          <NumberFormat
                            value={result.data.finauta_monthly_payment[paymentPeriodsIndex]}
                            displayType="text"
                            thousandSeparator
                            prefix="$"
                            decimalScale={0}
                          />
                        </StyledBold>
                      </Text>
                    </td>
                  </tr>
                  <tr>
                    {result.data.add_card_1 ? (
                      <td>
                        <Text type="body2">Tasa de interés</Text>
                      </td>
                    ) : (
                      <td>
                        <Text type="body2">Tasa de interés</Text>
                      </td>
                    )}
                    <td>
                      <Text type="body2">
                        <StyledBold>
                          <NumberFormat
                            value={result.data.original_weighted_annual_interest * 100}
                            decimalSeparator="."
                            displayType="text"
                            decimalScale={1}
                            suffix="%"
                          />
                        </StyledBold>
                      </Text>
                    </td>
                    <td>
                      <Text type="body2">
                        <StyledBold>
                          <NumberFormat
                            value={result.data.finauta_annual_interest * 100}
                            decimalSeparator="."
                            displayType="text"
                            decimalScale={1}
                            suffix="%"
                          />
                        </StyledBold>
                      </Text>
                    </td>
                  </tr>
                </StyledResultTable>
              </table>

              <NumberTip
                msg1="Tip: Cambia los años dando click en los botones "
                msg2="para ver cómo cambia tu ahorro"
                onClick={this.handleChange}
                minusAvailable={paymentPeriods[paymentPeriodsIndex - 1]}
                plusAvailable={paymentPeriods[paymentPeriodsIndex + 1]}
                arg1={-1}
                arg2={1}
              />

              <StyledCustomDivision />

              <ResultSubsection>
                <CTA
                  title="¿Sabes cómo cambiar tu deuda?"
                  subTitle="Nosotros te decimos cómo"
                  event="Deuda | Empezar ahora"
                  buttonText="Conocer opciones"
                  showFree={false}
                  onClick={() => {
                    window.location = '/contacto/deuda';
                  }}
                />
                <QuestionSection
                  styles={{ marginTop: '40px' }}
                  questions={[
                    {
                      title: '¿Cómo funciona?',
                      answers: [
                        {
                          bullets: [
                            'Cambiar tu deuda significa liquidar tu crédito caro y sustituirlo por un crédito más barato. Al tener una tasa de interés más baja, tu pago mensual será menor y ahorrarás intereses.',
                            'Finauta no te da un crédito, nosotros sólo te mostramos opciones y te ayudamos para que tú elijas la que más te convenga.',
                          ],
                        },
                      ],
                    },
                    {
                      title: 'Supuestos',
                      answers: [
                        {
                          subTitle: 'Escenario: tu banco',
                          bullets: [
                            'Las tasas de interés utilizadas en el análisis son las reportadas por cada banco y no incluyen cargos fijos por renovación y/o servicios adicionales',
                            'En el caso de que el usuario cuente con dos tarjetas, se paga primero la deuda de la tarjeta de crédito con mayor tasa de interés antes de realizar cualquier pago a la segunda tarjeta. Esto subestimaría el ahorro total en casos en los que la tarjeta de menor tasa de interés requiere pagos mínimos relativamente altos',
                            'Los cálculos presentados suponen que el usuario no se retrasa ni aumenta su deuda durante los meses de pago',
                          ],
                        },
                        {
                          subTitle: 'Escenario: tu mejor opción',
                          bullets: [
                            'Los resultados suponen que la totalidad de la deuda es transferida a una nueva tasa de interés especificada en la sección de resultado',
                            'Los cálculos presentados suponen que el usuario no se retrasa ni aumenta su deuda durante los meses de pago',
                          ],
                        },
                      ],
                    },
                  ]}
                />
              </ResultSubsection>
              <StartPlanResultCTA />
            </FirstSection>
          </Fragment>
        </StyledResults>
      </Fragment>
    ) : (
      <StyledResults style={{ backgroundColor: 'white' }}>
        <FlowHeader>
          <WhiteLogo src={FinautaWhiteLogo} id="logo" />
        </FlowHeader>
        <FirstSection>
          {failed ? (
            <Oops
              to="/deuda/empezar"
              event="Deuda | Resultados | Error | Empezar De Nuevo"
              onClick={this.forceUpdate}
            />
          ) : (
            <Loading title="Estamos calculando cuánto te ahorrarás por cambiar tu deuda..." />
          )}
        </FirstSection>
      </StyledResults>
    );
  }
}

Results.propTypes = {
  result: PropTypes.object,
};

Results.defaultProps = {
  result: {},
};

export default Results;
